import { render, staticRenderFns } from "./ShortcutsInfo.vue?vue&type=template&id=271e343f&scoped=true&"
import script from "./ShortcutsInfo.vue?vue&type=script&lang=js&"
export * from "./ShortcutsInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutsInfo.vue?vue&type=style&index=0&id=271e343f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271e343f",
  null
  
)

export default component.exports